var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"videoPlayer"},[_c('video',{attrs:{"id":"videoElement","width":"100%","height":"100%","controls":"","muted":""},domProps:{"muted":true}})])
}
var staticRenderFns = []

export { render, staticRenderFns }